const prefix = 'sectionhelper';
export const dataHooks = {
    closeButton: `${prefix}-close-btn`,
    title: `${prefix}-title`,
    content: `${prefix}-content`,
    actionButton: `${prefix}-action-btn`,
};
export const APPEARANCE = {
    Warning: 'warning',
    Standard: 'standard',
    Danger: 'danger',
    Success: 'success',
    Premium: 'premium',
    Preview: 'preview',
    ExperimentalDark: 'experimentalDark',
};
export const SIZE = {
    Small: 'small',
    Medium: 'medium',
};
//# sourceMappingURL=constants.js.map